import * as React from 'react'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Box from '@mui/material/Box'
import { FC } from 'react'

type TabPanelProps = {
  children?: React.ReactNode
  index: number
  value: number
}

export type BasicTabType = [string, FC]

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  )
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  }
}

type TabsProps = {
  tabComponents: BasicTabType[]
}
export default function BasicTabs({ tabComponents }: TabsProps) {
  const [value, setValue] = React.useState(0)

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue)
  }

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange}>
          {tabComponents.map(([title], index) => (
            <Tab key={index} label={title} {...a11yProps(index)} />
          ))}
        </Tabs>
      </Box>
      {tabComponents.map(([_, Comp], index) => (
        <CustomTabPanel key={index} index={index} value={value}>
          <Comp />
        </CustomTabPanel>
      ))}
    </Box>
  )
}
